export default import.meta.ROLLDOWN_FILE_URL_wwvAb_KlS8fN4pEG9patVw